import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const AudioTag = styled.audio`
  position: absolute;
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  transform: translateX(-50%);
  z-index: 2;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));

  ${(props) => props.act ? 'display: block;' : 'display : none;'}

  &::-webkit-media-controls-panel {
    background-color: #fff;
  }

  &::-webkit-media-controls-volume-control-container, &::-webkit-media-controls-current-time-display, &::-webkit-media-controls-time-remaining-display {
    display: none;
  }
`;

export const Audio = (props) => {
  return (
    <AudioTag
      autoplay={props.autoplay ? "autoplay" : ""}
      src={props.src}
      controls
      controlsList='nodownload noplaybackrate'
      act={props.act}
      bottom={props.bottom}
      left={props.left}
    />
  );
};

Audio.propTypes = {
  src : PropTypes.string.isRequired
};

Audio.defaultProps = {
  src : 'https://ccrma.stanford.edu/~jos/mp3/harpsi-cs.mp3',
  act : true,
  bottom : '10vw', 
  left : '10vw'
}